/**
 * Created by: Pranab Dhar
 */
import {integer, strEnum} from "../../types";

export const SCRIBE_SOLUTION_CLONE_TYPE = strEnum(["Solution", "SolutionByReferenceSource", "SolutionByReferenceTarget"]);
export type SCRIBE_SOLUTION_CLONE_TYPE = keyof typeof SCRIBE_SOLUTION_CLONE_TYPE;

export const SCRIBE_SOLUTION_AGENT_TYPE = strEnum(["OnPremise", "Cloud", "None"]);
export type SCRIBE_SOLUTION_AGENT_TYPE = keyof typeof SCRIBE_SOLUTION_AGENT_TYPE;

export const SCRIBE_SOLUTION_TYPE = strEnum(["Replication", "Integration", "IntegrationEvent", "Migration"]);
export type SCRIBE_SOLUTION_TYPE = keyof typeof SCRIBE_SOLUTION_TYPE;

export const SCRIBE_STATUS = strEnum(["Disabled", "Idle", "IdleLastRunRowErrors", "IdleLastRunFailed", "InProgress",
    "Preparing", "Provisioning", "ProvisionError", "Starting", "Incomplete", "Stopping", "OnDemand", "OnDemandLastRunFailed",
    "OnDemandLastRunRowErrors", "AgentUpdating", "AgentShutdown", "AgentHeartbeatLate", "AgentHeartbeatFailed", "WaitingForEvent",
    "WaitingToUpdateAgent", "WaitingToUpdateConnector", "UpdatingConnector", "WaitingToRestartAgentUserRequest",
    "WaitingToRestartAgentMemoryLimit", "AgentRestarting"]);
export type SCRIBE_STATUS = keyof typeof SCRIBE_STATUS;

export const SCRIBE_MAP_TYPE = strEnum(["ReplicationServicesMap", "IntegrationServicesBasicMap",
    "IntegrationServicesAdvancedMap", "IntegrationServicesAdvancedRequestResponseMap",
    "IntegrationServicesAdvancedMessageMap", "IntegrationServicesSysControllerMap"]);
export type SCRIBE_MAP_TYPE = keyof typeof SCRIBE_MAP_TYPE;

export interface IScribeMapLinksModel {
    enabled: boolean;
    valid: boolean;
    id: integer;
    index: integer;
    mapType: SCRIBE_MAP_TYPE;
    sources: string;
    targets: string;
    name: string;
    lockedBy: string;
    lockDate: string;
    eventUrl: string;
    lastModified: string;
    modifiedBy: string;
    description: string;
}

export const SCRIBE_SELECTION_TYPE = strEnum(["Recommended", "All", "Selected"]);
export type SCRIBE_SELECTION_TYPE = keyof typeof SCRIBE_SELECTION_TYPE;

export interface IScribeReplicationSettings {
    selectionType: SCRIBE_SELECTION_TYPE;
    entities: string[];
}

export interface IScribeSolution {

    id: string; // UUID/GUID
    name: string;
    agentId: string; // The GUID / UUID,
    description: string;
    connectionIdForSource: string; // The GUID / UUID,
    connectionIdForTarget: string; // The GUID / UUID,
    solutionType: SCRIBE_SOLUTION_TYPE;
    status: SCRIBE_STATUS;

    inProgressStartTime: string;

    lastRunTime: string;

    nextRunTime: string;

    mapLinks: IScribeMapLinksModel[];

    isDisabled: boolean;

    reasonDisabled: integer;

    minAgentVersion: string;

    modificationBy: string;

    replicationSettings: IScribeReplicationSettings;

    lastModificationDate: string;

    creationDate: string;

    solutionAgentType: SCRIBE_SOLUTION_AGENT_TYPE;

    solutionCloneType: SCRIBE_SOLUTION_CLONE_TYPE;
}

export interface IScribeSession {
    orgId: string;
    jwt: string;
}

/**
 * IScribeSolutionRoles
 */
export interface IScribeSolutionRoles {
    name: string;
}


export interface IScribeProperty {
    key: string;
    value: string;
}



